import React from 'react';
import GraphMessage from 'modules/campaigns/modules/campaigns-reports/components/Graph/GraphMessage';

export const DEMOGRAPHIC_COVERAGE_STATUS = {
    LOW: 'lowDemographicCoverage',
};

export const AudiencesInsightsDemographicsEmptyState = ({ dataStatus, moreInfo }) => {
    return moreInfo === DEMOGRAPHIC_COVERAGE_STATUS.LOW ? (
        <GraphMessage msgIdOverride="demographics-coverage-low" />
    ) : (
        <GraphMessage status={dataStatus} />
    );
};
